export const isPreviewRuntimeHost = (hostname: string) => {
  return (
    hostname.includes("-preview--") ||
    hostname.endsWith(".lovable.app") ||
    hostname.endsWith(".lovableproject.com") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  );
};

export const getAuthRedirectBase = () => {
  if (typeof window === "undefined") {
    return "https://app.roofgeniusai.com";
  }

  return isPreviewRuntimeHost(window.location.hostname)
    ? window.location.origin
    : "https://app.roofgeniusai.com";
};